import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Container } from 'ui/container/Container';
import { RelativeTime } from 'ui/utility/relativeTime';
import { ContentRestoreButton } from './ContentRestoreButton';
import { StyledIframeFullDoc, StyledDL } from './ContentPreview.styled';
import type { TemplateDiffContentPreviewProps, TemplateDiffContentEmail } from '../../types';

type ContentPreviewEmailProps = TemplateDiffContentEmail & TemplateDiffContentPreviewProps;

export const ContentPreviewEmail = ({
  onClick,
  templateId,
  ...content
}: ContentPreviewEmailProps) => {
  return (
    <Container size="medium" variant="primary" shadow="small">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <StyledDL>
            <dt>Created</dt>
            <dd>
              <RelativeTime timestamp={content.createdAt} />
            </dd>
            <dt>Created by</dt>
            <dd>{content.creatorUserId}</dd>
            <dt>Subject</dt>
            <dd>{content.subject}</dd>
            <dt>Preheader text</dt>
            <dd>{content.preheaderText}</dd>
            <dt>From email</dt>
            <dd>{content.fromEmail}</dd>
            <dt>From name</dt>
            <dd>{content.fromName}</dd>
          </StyledDL>
          <ContentRestoreButton contentId={content.id} onClick={() => onClick(content)} />
        </FlexSpacer>
        <Container size="small" hasBorder>
          <StyledIframeFullDoc isMaxHeightPref testId="message-preview-iframe">
            {content.html}
          </StyledIframeFullDoc>
        </Container>
      </FlexSpacer>
    </Container>
  );
};
